(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var dr = $('#dr');
  function drawer(o) { if (!dr) return; dr.classList.toggle('open', o); document.body.style.overflow = o ? 'hidden' : ''; }
  $$('[data-drawer]').forEach(function (b) { b.addEventListener('click', function () { drawer(b.dataset.drawer === 'open'); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer(false); });
  $$('#dr a').forEach(function (a) { a.addEventListener('click', function () { drawer(false); }); });

  $$('[data-tabs]').forEach(function (t) {
    var bs = $$('button', t), ps = $$('[data-panel]', t.parentNode);
    bs.forEach(function (b, i) { b.addEventListener('click', function () {
      bs.forEach(function (x, j) { x.classList.toggle('on', i === j); });
      ps.forEach(function (p, j) { p.hidden = i !== j; });
    }); });
  });

  $$('[data-product]').forEach(function (p) {
    var vsEl = $('[data-variants]', p); if (!vsEl) return;
    var vs = JSON.parse(vsEl.textContent), idEl = $('input[data-id]', p);
    var btn = $('[data-add]', p), buy = $('[data-buy]', p), price = $('[data-price]', p), fs = $$('fieldset[data-opt]', p);
    var skuEl = $('[data-sku]', p), colorFs = $('fieldset[data-color]', p);
    var c = $('[data-car]', p), go = function () {}, showColor = function () {};
    if (c) {
      var all = $$('.sl', c), sl = all, pv = $('[data-car-prev]', p), nx = $('[data-car-next]', p), cnt = $('[data-car-count]', p);
      var thb = $$('[data-go]', p), thi = $('.thi', p);
      var idx = function () { return Math.round(c.scrollLeft / (c.clientWidth || 1)); };
      go = function (i, now) {
        i = Math.max(0, Math.min(sl.length - 1, i));
        c.scrollTo({ left: i * c.clientWidth, behavior: now ? 'auto' : 'smooth' });
        if (now) sync();
      };
      // vignette -> index de la diapo visible correspondante (data-go = index d'origine)
      var goOrig = function (o) { var i = sl.indexOf(all[o]); if (i > -1) go(i); };
      var sync = function () {
        var i = idx(), cur = sl[i];
        thb.forEach(function (b) {
          var on = all[+b.dataset.go] === cur; b.classList.toggle('on', on);
          if (on && thi && b.offsetParent) { // garde la vignette active visible SANS faire défiler la page
            var r = b.getBoundingClientRect(), t = thi.getBoundingClientRect();
            if (r.top < t.top) thi.scrollTop -= t.top - r.top; else if (r.bottom > t.bottom) thi.scrollTop += r.bottom - t.bottom;
            if (r.left < t.left) thi.scrollLeft -= t.left - r.left; else if (r.right > t.right) thi.scrollLeft += r.right - t.right;
          }
        });
        if (cnt) cnt.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + sl.length).slice(-2);
        if (pv) pv.disabled = i === 0; if (nx) nx.disabled = i >= sl.length - 1;
        if (pv) pv.hidden = sl.length < 2; if (nx) nx.hidden = sl.length < 2;
      };
      // Affiche les images de la couleur choisie + les images partagées (sans couleur).
      // Si aucune image n'est liée à cette couleur, on garde toute la galerie.
      showColor = function (color, first) {
        var key = '|' + String(color || '').toLowerCase() + '|';
        var has = color && all.some(function (s) { return (s.dataset.colors || '').indexOf(key) > -1; });
        sl = all.filter(function (s) { var k = s.dataset.colors; return !has || (k && (k.indexOf(key) > -1 || k.indexOf('|*|') > -1)); });
        all.forEach(function (s) { s.hidden = sl.indexOf(s) < 0; });
        thb.forEach(function (b) { b.hidden = sl.indexOf(all[+b.dataset.go]) < 0; });
        // se placer sur l'image de la variante si elle existe, sinon sur la première
        var cv = vs.find(function (v) { return v.id === +idEl.value; }), at = 0;
        if (cv && cv.mid) sl.forEach(function (s, i) { if (+s.dataset.id === cv.mid) at = i; });
        c.scrollLeft = at * c.clientWidth; sync();
      };
      c.addEventListener('scroll', function () { clearTimeout(c._t); c._t = setTimeout(sync, 60); });
      thb.forEach(function (b) { b.addEventListener('click', function () { goOrig(+b.dataset.go); }); });
      if (pv) pv.addEventListener('click', function () { go(idx() - 1); });
      if (nx) nx.addEventListener('click', function () { go(idx() + 1); });
      window.addEventListener('resize', function () { c.scrollLeft = idx() * c.clientWidth; });
      sync();
    }
    var stkEl = $('[data-stock]', p), sticky = $('[data-sticky]', p), stAdd = $('[data-sticky-add]', p), stPrice = $('[data-sticky-price]', p);
    var colorIdx = colorFs ? fs.indexOf(colorFs) : -1, low = (window.CL && CL.low) || 5;
    function sel() { return fs.map(function (f) { var ck = $('input:checked', f); return ck ? ck.value : null; }); }
    // grise les options épuisées ou inexistantes
    function mark() {
      var s = sel();
      fs.forEach(function (f, i) {
        $$('input', f).forEach(function (inp) {
          var val = inp.value, ok = vs.some(function (v) {
            return v.options[i] === val && v.available && (i === colorIdx || colorIdx < 0 || v.options[colorIdx] === s[colorIdx]);
          });
          inp.parentNode.classList.toggle('so', !ok);
          var sp = inp.nextElementSibling; if (sp) sp.setAttribute('title', ok ? (colorIdx === i ? val : '') : val + ' — indisponible');
        });
      });
    }
    function stock(v) {
      if (!stkEl) return;
      var t = '';
      if (v && v.available && v.qty > 0 && v.qty <= low) t = 'Plus que ' + v.qty + ' en stock';
      else if (v && !v.available) t = 'Cette combinaison est épuisée';
      stkEl.textContent = t; stkEl.hidden = !t; stkEl.classList.toggle('low', !!(v && v.available));
    }
    function syncSticky() {
      if (!sticky || !btn) return;
      stAdd.textContent = btn.textContent; stAdd.disabled = btn.disabled;
      if (stPrice && price) stPrice.textContent = ($('span', price) || {}).textContent || '';
    }
    if (sticky && btn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (en) { sticky.classList.toggle('on', !en[0].isIntersecting); }, { threshold: 0 }).observe(btn);
      stAdd.addEventListener('click', function () { if (btn.form && btn.form.requestSubmit) btn.form.requestSubmit(btn); else btn.click(); });
    }
    function update(ev) {
      var sel = fs.map(function (f) { var ck = $('input:checked', f); return ck ? ck.value : null; });
      fs.forEach(function (f) { var ck = $('input:checked', f), l = $('[data-val]', f); if (ck && l) l.textContent = ck.value; });
      var v = vs.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
      if (!v && colorFs && ev && ev.target && colorFs.contains(ev.target)) {
        // combinaison absente (ex. taille inexistante dans ce coloris) : on bascule sur la 1re variante de la couleur
        var ci = fs.indexOf(colorFs), alt = vs.filter(function (x) { return x.options[ci] === sel[ci]; });
        v = alt.find(function (x) { return x.available; }) || alt[0];
        if (v) fs.forEach(function (f, i) { $$('input', f).forEach(function (inp) { inp.checked = inp.value === v.options[i]; }); var l = $('[data-val]', f); if (l) l.textContent = v.options[i]; });
      }
      if (!v) { btn.disabled = true; if (buy) buy.disabled = true; btn.textContent = 'Indisponible'; return; }
      idEl.value = v.id;
      if (price) price.innerHTML = '<span>' + v.price + '</span>' + (v.compare ? '<s>' + v.compare + '</s><span class="off">-' + v.off + '%</span>' : '');
      if (skuEl) skuEl.textContent = v.sku || '';
      btn.disabled = !v.available; if (buy) buy.disabled = !v.available;
      btn.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      mark(); stock(v); syncSticky();
      if (c) {
        var ck = colorFs && $('input:checked', colorFs), colorChanged = !ev || !ev.target || (colorFs && colorFs.contains(ev.target));
        if (colorChanged) showColor(ck ? ck.value : null);
        else if (v.mid) { for (var i = 0; i < sl.length; i++) if (+sl[i].dataset.id === v.mid) go(i); }
      }
      if (/^\/products\//.test(location.pathname)) history.replaceState(null, '', '?variant=' + v.id);
    }
    fs.forEach(function (f) { f.addEventListener('change', update); });
    if (c && colorFs) { var ck0 = $('input:checked', colorFs); if (ck0) showColor(ck0.value, true); }
    mark(); stock(vs.find(function (v) { return idEl && v.id === +idEl.value; })); syncSticky();
  });

  $$('[data-qty]').forEach(function (b) { b.addEventListener('click', function () {
    var i = $('input', b.parentNode); i.value = Math.max(1, (+i.value || 1) + (+b.dataset.qty));
  }); });
  $$('[data-trk]').forEach(function (b) { b.addEventListener('click', function () {
    var t = $('.trk', b.closest('.bs')); t.scrollBy({ left: (+b.dataset.trk) * t.clientWidth * 0.9, behavior: 'smooth' });
  }); });

  $$('[data-rec]').forEach(function (el) {
    fetch(el.dataset.rec).then(function (r) { return r.text(); }).then(function (t) {
      var n = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-rec]');
      if (n && n.innerHTML.trim()) el.innerHTML = n.innerHTML;
    }).catch(function () {});
  });
})();

(function () {
  function filt(o) { document.body.classList.toggle('fopen', o); document.body.style.overflow = o ? 'hidden' : ''; }
  [].slice.call(document.querySelectorAll('[data-filter]')).forEach(function (b) { b.addEventListener('click', function () { filt(b.dataset.filter === 'open'); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') filt(false); });
})();

/* ===== Panier latéral, quantités, recherche prédictive ===== */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var CL = window.CL || {};
  var cd = $('#cd'), ov = $('.cd-o'), lastFocus = null;
  var fmt = function (n) { try { return new Intl.NumberFormat(CL.lang || undefined, { style: 'currency', currency: CL.cur || 'EUR' }).format(n); } catch (e) { return n; } };

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
    $$('[data-cart-link]').forEach(function (a) { a.setAttribute('aria-label', 'Panier (' + n + ')'); });
  }
  function openCart() {
    if (!cd) return;
    lastFocus = document.activeElement;
    ov.hidden = false; cd.classList.add('open'); cd.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { ov.classList.add('open'); });
    document.body.style.overflow = 'hidden';
    var x = $('[data-cd-close]', cd); if (x) x.focus();
  }
  function closeCart() {
    if (!cd) return;
    cd.classList.remove('open'); ov.classList.remove('open'); cd.setAttribute('aria-hidden', 'true');
    setTimeout(function () { ov.hidden = true; }, 300);
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function render(html) {
    if (!cd || !html) return;
    var n = new DOMParser().parseFromString(html, 'text/html').getElementById('cd'); if (!n) return;
    cd.innerHTML = n.innerHTML; setCount(+n.dataset.count || 0);
  }
  function refresh() {
    if (!cd) return Promise.resolve();
    return fetch(CL.cart + '?sections=cart-drawer').then(function (r) { return r.json(); })
      .then(function (j) { render(j['cart-drawer']); }).catch(function () {});
  }
  function showErr(msg) { var e = $('[data-cd-err]', cd); if (e) { e.textContent = msg; e.hidden = !msg; } }

  if (cd) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-close]')) { closeCart(); return; }
      var l = e.target.closest('[data-cart-link]');
      if (l && location.pathname.replace(/\/$/, '') !== String(CL.cart).replace(/\/$/, '')) { e.preventDefault(); refresh().then(openCart); return; }
      var b = e.target.closest('[data-cd-q]');
      if (b && cd.contains(b)) {
        var line = b.closest('[data-key]'); if (!line) return;
        $$('button', cd).forEach(function (x) { x.disabled = true; });
        fetch(CL.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.dataset.key, quantity: +b.dataset.cdQ, sections: 'cart-drawer' }) })
          .then(function (r) { return r.json(); })
          .then(function (j) { if (j.sections) render(j.sections['cart-drawer']); if (j.description) showErr(j.description); else showErr(''); })
          .catch(function () { refresh(); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cd.classList.contains('open')) closeCart(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  // Ajout au panier sans rechargement (le bouton « Acheter maintenant » garde l'envoi classique)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!cd || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    if (e.submitter && e.submitter.hasAttribute('data-buy')) return;
    e.preventDefault();
    var btn = $('[data-add]', f), txt = btn && btn.textContent, was = btn && btn.disabled;
    if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
    var old = $('.pferr', f); if (old) old.remove();
    var fd = new FormData(f); fd.append('sections', 'cart-drawer');
    fetch(CL.add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (o) {
        if (!o.ok) { var p = document.createElement('p'); p.className = 'pferr'; p.setAttribute('role', 'alert'); p.textContent = o.j.description || 'Impossible d’ajouter ce produit.'; f.appendChild(p); return; }
        render(o.j.sections && o.j.sections['cart-drawer']); openCart();
      })
      .catch(function () { f.submit(); })
      .then(function () { if (btn) { btn.disabled = was; btn.textContent = txt; } });
  });

  // Page panier : boutons +/- et mise à jour automatique
  $$('[data-cart-form]').forEach(function (f) {
    var up = $('[data-cp-update]', f), t;
    var send = function () { if (f.requestSubmit && up) f.requestSubmit(up); else f.submit(); };
    $$('[data-cp-step]', f).forEach(function (b) { b.addEventListener('click', function () {
      var i = $('[data-cp-qty]', b.parentNode); i.value = Math.max(0, (+i.value || 0) + (+b.dataset.cpStep));
      clearTimeout(t); t = setTimeout(send, 450);
    }); });
    $$('[data-cp-qty]', f).forEach(function (i) { i.addEventListener('change', function () { clearTimeout(t); t = setTimeout(send, 300); }); });
    if (up) up.hidden = true;
  });

  // Recherche prédictive
  var sr = $('#sr'), inp = sr && $('[data-sr-input]', sr), res = sr && $('[data-sr-results]', sr), st, ac;
  function openS() { sr.hidden = false; document.body.style.overflow = 'hidden'; setTimeout(function () { inp.focus(); }, 30); }
  function closeS() { sr.hidden = true; document.body.style.overflow = ''; }
  if (sr) {
    $$('[data-search-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); openS(); }); });
    $$('[data-search-close]', sr).forEach(function (b) { b.addEventListener('click', closeS); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sr.hidden) closeS(); });
    inp.addEventListener('input', function () {
      clearTimeout(st); var q = inp.value.trim();
      if (q.length < 2) { res.textContent = ''; return; }
      st = setTimeout(function () {
        if (ac) ac.abort(); ac = window.AbortController ? new AbortController() : null;
        fetch(CL.suggest + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', ac ? { signal: ac.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
            res.textContent = '';
            if (!ps.length) { var p = document.createElement('p'); p.className = 'mut'; p.textContent = 'Aucun résultat pour « ' + q + ' ».'; res.appendChild(p); return; }
            ps.forEach(function (p) {
              var a = document.createElement('a'); a.href = p.url; a.className = 'srp';
              if (p.image) { var im = document.createElement('img'); im.src = p.image; im.alt = ''; im.width = 56; im.height = 70; im.loading = 'lazy'; a.appendChild(im); }
              var d = document.createElement('span'), t = document.createElement('b'), pr = document.createElement('small');
              t.textContent = p.title; pr.textContent = fmt(parseFloat(p.price)); d.appendChild(t); d.appendChild(pr); a.appendChild(d); res.appendChild(a);
            });
            var all = document.createElement('a'); all.className = 'btn o srall'; all.href = CL.search + '?type=product&q=' + encodeURIComponent(q); all.textContent = 'Voir tous les résultats'; res.appendChild(all);
          }).catch(function () {});
      }, 200);
    });
  }
})();

(function () {
  var $$ = function (s) { return [].slice.call(document.querySelectorAll(s)); };
  $$('[data-modal]').forEach(function (b) { b.addEventListener('click', function () {
    var d = document.getElementById(b.dataset.modal); if (d && d.showModal) d.showModal();
  }); });
  $$('dialog.mdl').forEach(function (d) {
    d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-modal-close]')) d.close(); });
  });
})();

/* Cartes produit : survol d'une pastille = image de cette couleur */
(function () {
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.csw'); if (!sw || !sw.dataset.img) return;
    var im = sw.closest('.pc').querySelector('.ph img'); if (!im) return;
    if (!im._o) im._o = { src: im.getAttribute('src'), srcset: im.getAttribute('srcset') };
    im.removeAttribute('srcset'); im.src = sw.dataset.img;
  });
  document.addEventListener('mouseout', function (e) {
    var c = e.target.closest && e.target.closest('.csws'); if (!c || c.contains(e.relatedTarget)) return;
    var im = c.closest('.pc').querySelector('.ph img'); if (!im || !im._o) return;
    im.src = im._o.src; if (im._o.srcset) im.setAttribute('srcset', im._o.srcset); im._o = null;
  });
})();
